import { basicBaseApi } from "./basicBaseApi";
import { Methods } from '@newview/infrastructure';


export class RoadlaneinforApi extends basicBaseApi {

  public get ControllerName(): any {
    return 'roadlaneinfor'
  }

  /**
   * 查询列表(分页)
   * @param params
   * @returns 
   */
  public getListByParams(params) {
    return this.send(params, "getListByParams", Methods.GET)
  }

}